























































import { Component, Prop, Vue } from 'vue-property-decorator';
import UserStore, { UserStoreInterface } from '@/resource/user/user.store';
import { validateEmail, validateNotEmpty } from '@/utils/form-validation';
import BeatLoader from 'vue-spinner/src/BeatLoader.vue';
import { ErrorCode } from '@/utils/response';

interface SignupForm {
  id: string;
  value: string;
  type: string;
  errorMessage: string | boolean;
  placeholder: string;
}

interface ValidatePhoneNumber {
  number: { e164: string };
  isValid: boolean;
  country: string;
}

@Component({
  components: {
    BeatLoader,
  },
})
export default class Signup extends Vue {
  @Prop({ default: false })
  notSignupPage: boolean;

  userStore: UserStoreInterface = UserStore;

  isLoading = false;
  phoneNumberStatus: ValidatePhoneNumber | null = null;

  signupForms: SignupForm[] = [
    {
      id: 'firstName',
      value: '',
      type: 'text',
      errorMessage: false,
      placeholder: 'Nama sendiri',
    },
    {
      id: 'lastName',
      value: '',
      type: 'text',
      errorMessage: false,
      placeholder: 'Nama keluarga',
    },
    {
      id: 'email',
      value: '',
      type: 'email',
      errorMessage: false,
      placeholder: 'Emel',
    },
    {
      id: 'phoneNumber',
      value: '',
      type: 'text',
      errorMessage: false,
      placeholder: 'Nombor telefon',
    },
    {
      id: 'password',
      value: '',
      type: 'password',
      errorMessage: false,
      placeholder: 'Kata laluan',
    },
  ];

  get intialEmail(): string {
    const email = this.$route.query['email'];
    if (email && typeof email === 'string') {
      return email;
    } else {
      return '';
    }
  }

  get redirectTo(): string {
    if (typeof this.$route.query.redirect === 'string') {
      return this.$route.query.redirect.trim();
    } else {
      return '';
    }
  }

  created() {
    if (this.intialEmail) {
      this.signupForms[2].value = this.intialEmail;
    }
  }

  async signupSubmitted() {
    if (this.isLoading) return;
    this.isLoading = true;

    if (this.validateForms()) {
      this.isLoading = false;
      return;
    }

    const newUser: any = {};

    this.signupForms.forEach(signupForm => {
      if (signupForm.id !== 'retypePassword') {
        newUser[signupForm.id] = signupForm.value;
      }
    });

    await this.userStore.signup(newUser);

    if (this.userStore.error) {
      this.$sendMpEvent({
        event: this.$mp_value.ErrorSignup,
        properties: {
          error: this.userStore.error.message,
          email: newUser ? newUser.email : '',
        },
      });

      if (this.userStore.error.code === ErrorCode.EmailInUsedError) {
        this.signupForms = this.signupForms.map(signupForm => {
          if (signupForm.id === 'email') {
            signupForm.errorMessage = `Email already taken`;
          }
          return signupForm;
        });
      }
    } else {
      await this.userStore.signin({
        email: newUser.email,
        password: newUser.password,
      });

      this.$sendMpEvent({
        event: this.$mp_value.Signup,
        properties: {
          email: newUser.email,
          phoneNumber: newUser.phoneNumber,
        },
      });

      this.redirectUser();
    }
    this.isLoading = false;
  }

  validatePhoneNumber(param: ValidatePhoneNumber) {
    this.phoneNumberStatus = param;
  }

  validateForms(): boolean {
    let hasError = false;

    this.signupForms = this.signupForms.map(signupForm => {
      if (!validateNotEmpty(signupForm.value)) {
        signupForm.errorMessage = `${this.getTitle(
          signupForm.id,
        )} cannot empty`;

        hasError = true;
      } else {
        signupForm.errorMessage = false;
      }

      if (signupForm.id === 'email') {
        if (!validateEmail(signupForm.value)) {
          signupForm.errorMessage = `Not valid email`;

          hasError = true;
        } else {
          signupForm.errorMessage = false;
        }
      }

      if (signupForm.id === 'phoneNumber' && this.phoneNumberStatus) {
        if (!this.phoneNumberStatus.isValid) {
          signupForm.errorMessage = `Phone number is not valid`;

          hasError = true;
        } else {
          signupForm.errorMessage = false;
          signupForm.value = this.phoneNumberStatus.number.e164;
        }
      }

      return signupForm;
    });

    const password = this.signupForms.find(
      signupForm => signupForm.id === 'password',
    );
    const retypePassword = this.signupForms.find(
      signupForm => signupForm.id === 'retypePassword',
    );

    if (password && password.value.length && password.value.length < 6) {
      password.errorMessage = `Password must be at least 6 characters`;
      hasError = true;
      return hasError;
    }

    if (password && retypePassword && password.value !== retypePassword.value) {
      password.errorMessage = `Password not match`;
      retypePassword.errorMessage = `Password not match`;
      hasError = true;
    }

    return hasError;
  }

  getTitle(title: string) {
    const separatedText = this.$lodash.startCase(title).toLowerCase();
    return this.$lodash.upperFirst(separatedText);
  }

  redirectUser() {
    if (this.notSignupPage) {
      this.$router.go(0);
      return;
    }

    if (this.$router.currentRoute.name === 'subjects') {
      this.$router.go(0);
    } else if (this.redirectTo) {
      this.$router.push({
        path: this.redirectTo,
      });
    } else {
      this.$router.push({
        name: 'browse',
      });
    }
  }

  signinClick() {
    this.$router.push({
      path: '/signin',
    });
  }

  phoneNumberFixed =
    'bg-white-100 text-14 text-black-100 rounded py-14 px-14 w-full leading-normal';

  phoneNumberMain = `${this.phoneNumberFixed} border-white-100 border-solid border-1`;
  phoneNumberError = `${this.phoneNumberFixed} bg-red-300 border-red-100 border-solid border-1`;
}
